module.exports = {
  commonComponentEvents: {
    BrowserError: {
      code: 'BROWSER',
      events: {
        onerror: {
          eventHub: {
            code: 'ERROR',
            action: '[$.message]',
            dataKeys: ['error']
          }
        },
        unhandledrejection: {
          eventHub: {
            code: 'API_ERROR',
            action: '[$.message]',
            dataKeys: ['error']
          }
        }
      }
    },
    PhoneTextField: {
      code: 'PH',
      events: {
        change: {
          eventHub: {
            code: 'CHNG',
            action: 'Phone No: [$.PhoneNo]',
            dataKeys: ['PhoneNo']
          },
          ga: {
            action: 'Phone Chnaged to [$.PhoneNo]'
          }
        },
        load: {
          description: 'raise on mount of PhoneTextField component',
          eventHub: {
            code: 'LOD',
            action: 'Phone: [$.PhoneNo]'
          },
          ga: {
            action: 'Entered [$.PhoneNo] as Phone Number'
          }
        }
      }
    },
    PersonalInfo: {
      code: 'PI',
      events: {
        submit: {
          description: 'Triggered when the Sub/CoSub Personal Info submitted',
          eventHub: {
            code: 'CONF',
            action: 'Complete [$.clientType] details',
            dataKeys: [
              'firstName',
              'middleName',
              'lastName',
              'phone',
              'dob',
              'birthDay',
              'birthMonth',
              'birthYear',
              'city',
              'province',
              'streetNumber',
              'unitNumber',
              'streetName',
              'postalCode'
            ]
          },
          ga: {
            action: '[$.clientType] – Save PersonalInfo'
          }
        }
      }
    },
    PlanSelect: {
      code: 'SelectPlan',
      events: {
        SelectPlan: {
          description:
            'Triggered when the plan number is submitted after selection',
          eventHub: {
            action: 'SelectPlan',
            dataKeys: ['PlanAccountId']
          },
          ga: {
            action: 'Select Plan'
          }
        }
      }
    },
    ChildDetailsForm: {
      code: 'BeneDetails',
      events: {
        BeneDetails: {
          description: 'Triggered when the child details are submitted',
          eventHub: {
            action: 'BeneDetails',
            dataKeys: [
              'firstName',
              'middleName',
              'lastName',
              'birthDay',
              'birthMonth',
              'birthYear',
              'gender',
              'relationship',
              'isCustodialParent'
            ]
          },
          ga: {
            action: 'Submit Bene Details'
          }
        }
      }
    },
    BillPayment: {
      code: 'BillPayment',
      events: {
        popup: {
          eventHub: {
            code: 'BillPaymentModal',
            action: 'View Bill Payment Steps'
          },
          ga: {
            action: 'View Bill Payment Steps'
          }
        },
        copyAccount: {
          eventHub: {
            code: 'BillPaymentModal',
            action: 'Copy Account Number for Bill payment'
          },
          ga: {
            action: 'Copy Account Number for Bill payment'
          }
        }
      }
    }
  }
};
